module.exports = __webpack_public_path__ + "img/setting-2.5ec8e7a1.svg";